<template>
  <div id="app">
    <div class="qr-code-content">
      <div class="page-code-wrap">
        <div id="qr-code"></div>
      </div>
      <div class="page-code-text">手机扫码使用体验更佳</div>
    </div>
    <router-view/>

  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    
  },
  watch:{
    $route(to,from){
       to.name&&(document.title = to.name)
       this.getPageCode()
       let postData = {
             url: window.location.href,
             title: '云合影',
             image: 'https://pics.usho.cn/schoollogo/2382.jpg'
           };
         wx.miniProgram.postMessage({ data: JSON.stringify(postData) });
    }
},
  mounted(){
     if($.device.isWeixin){
      $('.qr-code-content').css('display','none')
    }
    document.addEventListener("WeixinJSBridgeReady", function() {  
      var _size = Math.floor(document.documentElement.clientWidth * 20 / 320) // rem计算的值 

      WeixinJSBridge.on("menu:setfont", function(e) {
          //e.fontSize,e.fontScale
          switch (+e.fontSize) {
              case 1:
                  document.getElementsByTagName('html')[0].style.fontSize = (_size - 2) + 'px'
                  break;
              case 2:
                  document.getElementsByTagName('html')[0].style.fontSize = _size + 'px'
                  break;
              case 3:
                  document.getElementsByTagName('html')[0].style.fontSize = (_size + 1) + 'px'
                  break;
              case 4:
                  document.getElementsByTagName('html')[0].style.fontSize = (_size + 2) + 'px'
                  break;
              case 5:
                  document.getElementsByTagName('html')[0].style.fontSize = (_size + 3) + 'px'
                  break;
              case 6:
                  document.getElementsByTagName('html')[0].style.fontSize = (_size + 4) + 'px'
                  break;
              case 7:
                  document.getElementsByTagName('html')[0].style.fontSize = (_size + 5) + 'px'
                  break;
              case 8:
                  document.getElementsByTagName('html')[0].style.fontSize = (_size + 6) + 'px'
                  break;
          }
          WeixinJSBridge.invoke("setFontSizeCallback", {
              fontSize: 0
          })
      })
      //样式也控制禁止放大缩小
      var doc = document.documentElement;
      doc.style.webkitTextSizeAdjust = "none"
    }, !1);
  },
  methods:{
    getPageCode(){
      document.getElementById("qr-code").innerHTML = '';
      var qrcode = new QRCode(document.getElementById("qr-code"), {
        width: 120,
        height: 120
      });
      qrcode.makeCode(window.location.href)
    }
  },
}
</script>

<style lang="less">
html,body{
  width: 100%;
  height: 100%;
  margin:0;
  padding:0;
}
// *{
//   max-width: 800px;
// }
#app {
  width: 100%;
  height: 100%;
  max-width: 800px;
  margin: 0 auto;
  box-shadow: 0 0.2rem 1rem rgb(100 100 100 / 30%);
  position: relative;
  .qr-code-content{
    position:absolute;
    top: 10px;
    left: 50%;
    z-index: 10;
    width: 180px;
    height: 220px;
    border-radius: 8px;
    margin-left: 440px;
    background-color: #FFF!important;
    box-shadow: 0 8px 16px 0 rgb(0 0 0 / 10%);
    .page-code-wrap{
      width: 140px;
      height: 140px;
      border: 1px solid #C7C7C7;
      margin: 20px auto;
      padding: 10px;
      #qr-code{
        width: 120px;
        height: 120px;
        margin: 0 auto;
      }
    }
    .page-code-text{
      font-size: 16px;
      color: #666;
      text-align: center;
      line-height: 1;
    }
  }
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
.mint-toast,.mint-indicator-mask,.mint-indicator-wrapper{
  z-index: 5000 !important;
}
.mint-popup{
  max-width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue